import isEqual from "lodash.isequal"
import { createActions, createReducer } from "reduxsauce"
import Immutable from "seamless-immutable"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getBusinessAccountsFilterOptionsRequest: null,
  getBusinessAccountsFilterOptionsSuccess: ["payload"], // payload: { data }
  getBusinessAccountsFilterOptionsFailure: ["payload"], // payload: { data }

  getAdminBusinessAccountsRequest: ["payload"], // payload: { params }
  getAdminBusinessAccountsSuccess: ["payload"], // payload: { data }

  getBaCommentDataRequest: ['payload'], // payload: { params }
  getBaCommentDataSuccess: ['payload'], // payload: { data }

  saveBaCommentRequest: ['payload'], // payload: { params }
  saveBaCommentSuccess: ['payload'], // payload: { data }

  deleteBaCommentRequest: ['payload'], // payload: { params }
  deleteBaCommentSuccess: ['payload'], // payload: { data }

  deleteBaCommentAttachmentRequest: ['payload'], // payload: { params }
  deleteBaCommentAttachmentSuccess: ['payload'], // payload: { data }

  deleteUserBusinessAccountRequest: ["payload"], // payload: { params }
  deleteUserBusinessAccountSuccess: ["payload"], // payload: { data }

  businessAccountsFailure: ["payload"], // payload: { errors }

  clearBusinessAccountsFilters: null,
  clearBaCommentsData : null,
  businessAccountsSetProp: ["key", "value"],

  getBusinessAccountsExportRequest: ["payload"], // payload: { business_id }
  getBusinessAccountsExportSuccess: ["payload"], // payload: { url }
  getBusinessAccountsExportFailure: ["payload"], // payload: { errors }

  getAlertsChartRequest: ["payload"], // payload: { business_id }
  getAlertsChartSuccess: ["payload"], // payload: { chartData }
  getAlertsChartFailure: ["payload"], // payload: { errors }

  getStatisticsAdminRequest: ["payload"],
  getStatisticsAdminSuccess: ["payload"], // payload: { statistics }
  getStatisticsAdminFailure: ["payload"], // payload: { errors }

  logout: null
})

export const BusinessAccountsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

const columnsAdmin = [
  { field_id: "steps_finished", label: "Steps finished", active: true },
  { field_id: "mode", label: "Mode", active: true },
  { field_id: "user_full_name", label: "User full name", active: true },
  { field_id: "user_email", label: "User email", active: true },
  { field_id: "alerts_count", label: "Alerts sent", active: true },
  { field_id: "paid_alerts_count", label: "Paid Alerts", active: true },
  { field_id: "alerts_in_debt_count", label: "Alerts in Debt", active: true },
  { field_id: "business_account", label: "Business account", active: true },
  { field_id: "business_url", label: "Business URL", active: true },
  { field_id: "merchant_descriptor", label: "Billing descriptor", active: true },
  { field_id: "enrollments", label: "Enrollments", active: true },
  { field_id: "created_timestamp", label: "Creation date", active: true },
  { field_id: "user_card", label: "Card", active: true },
  { field_id: "balance_current", label: "Current Balance", active: true },
  { field_id: "updated_bh", label: "Updated BH", active: true },
  { field_id: "connected_payment_processors", label: "Payment processor", active: true },

  { field_id: "enable_auto_refunds", label: "Auto-refund Ethoca&CDRN", active: true },
  { field_id: "auto_refund_amount_other", label: "Auto-refund amount Ethoca&CDRN", active: true },
  { field_id: "auto_refund_amount_rdr", label: "Auto-refund amount RDR", active: true },
  { field_id: "media_source", label: "How did you hear about us", active: true },
  { field_id: "pricing_schema", label: "Pricing scheme", active: true },
  { field_id: "auto_cancel_subscriptions", label: "Auto-cancel subscriptions", active: true },
  { field_id: "auto_cancel_amount", label: "Auto-cancel amount", active: true },
  { field_id: "visits_per_month", label: "Visits per month", active: true },
  { field_id: "visits_updated", label: "Visits updated", active: true }
]

export const INITIAL_STATE = Immutable({
  fetching: false,
  result: {
    count: 0,
    next: null,
    previous: null,
    results: []
  },

  defaultColumnsAdmin: [{ field_id: "status", label: "Status" }, ...columnsAdmin],
  columnsAdmin: [...columnsAdmin],

  filtersLastUpd: null,
  filters: {
    status: "all",

    steps_finished: "all",
    user_full_name: [],
    user_email: [],
    business_account: [],
    business_url: [],

    amount: { min: null, max: null, type: null },
    merchant_descriptor: "all",
    connected_payment_processors: "all",
    updated_bh: "all",
    alert_id: [],
    user_card: [],

    alerts_count: { min: null, max: null, type: null },
    paid_alerts_count: { min: null, max: null, type: null },
    alerts_in_debt_count: { min: null, max: null, type: null },
    enrollments: [],
    created_timestamp: null,
    enable_auto_refunds: "all",
    auto_refund_amount_other: { min: null, max: null, type: null },
    auto_refund_amount_rdr: { min: null, max: null, type: null },
    balance_current: { min: null, max: null, type: null },
    media_source: "all",
    pricing_schema: "all",
    auto_cancel_subscriptions: "all",
    balance_usage: "all",
    demo_mode: "all",
    auto_cancel_amount: { min: null, max: null, type: null },
    exclude_fields: []
  },

  fetchingFilterOptions: false,
  filterOptions: {
    status: [],
    country: [],
    bank_name: [],
    connected_payment_processors: [],
    pricing_schema: [],
    auto_cancel_subscriptions: []
  },

  visibleFiltersAdmin: { status: true, user_email: true, business_account: true, alerts_count: true },

  exportFetching: false,
  exportResult: null,

  chartLoading: false,
  chartData: {
    last_updated: null,
    chart: {
      labels: [],
      result: {}
    },
    total_value: null
  },

  fetchingStatistics: false,
  statistics: {
    users_counter: 0,
    enrollments_counter: {
      all: null,
      new: null,
      processed: null,
      archive: null,
      need_communication: null
    },
    descriptors_counter: {
      all: null,
      new: null,
      processed: null,
      archive: null,
      need_communication: null
    },
    auto_refund_counter: {
      all: null,
      new: null,
      processed: null,
      archive: null,
      need_communication: null
    },
    "requests_counter": 0,
    "integrations_counter": 0,
    "shopify_invoice_counter": 0,
  },

  fetchingBaComment: false,
  baCommentData: null,
})

/* ------------- Selectors ------------- */
export const selectAreFiltersDefault = (state) =>
  isEqual(state.businessAccounts.filters, INITIAL_STATE.filters)

/* ------------- Functions for reducer cases ------------- */
const getStatisticsAdminRequest = (state) => state.merge({ fetchingStatistics: true })
const getStatisticsAdminSuccess = (state, { payload: statistics }) =>
  state.merge({ fetchingStatistics: false, statistics })
const getStatisticsAdminFailure = (state) => state.merge({ fetchingStatistics: false })

const getBusinessAccountsFilterOptionsRequest = (state) =>
  state.merge({ fetchingFilterOptions: true })
const getBusinessAccountsFilterOptionsSuccess = (state, { payload: filterOptions }) =>
  state.merge({ fetchingFilterOptions: false, filterOptions })
const getBusinessAccountsFilterOptionsFailure = (state) =>
  state.merge({ fetchingFilterOptions: false })

const getBaCommentDataRequest = (state) => state.merge({fetchingBaComment: true})
const getBaCommentDataSuccess = (state, {payload: data}) => state.merge({fetchingBaComment: false, baCommentData: data})

const saveBaCommentRequest = (state) => state.merge({fetchingBaComment: true})
const saveBaCommentSuccess = (state, {payload: data}) => state.merge({
  fetchingBaComment: false,
  baCommentData: data,
})

const deleteBaCommentRequest = (state) => state.merge({fetchingBaComment: true})
const deleteBaCommentSuccess = (state, {payload: data}) => state.merge({
  fetchingBaComment: false,
  baCommentData: {...state.baCommentData, comment_text: null}
})

const deleteBaCommentAttachmentRequest = (state) => state.merge({fetchingBaComment: true})
const deleteBaCommentAttachmentSuccess = (state, {payload: data}) => state.merge({
  fetchingBaComment: false,
})

const getAdminBusinessAccountsRequest = (state) => state.merge({ fetching: true })
const getAdminBusinessAccountsSuccess = (state, { payload: result }) => {
  if (result.results) {
    return state.merge({ fetching: false, result })
  } else {
    return state.merge({
      fetching: false,
      result: {
        count: result?.length || 0,
        results: result
      }
    })
  }
}

const deleteUserBusinessAccountRequest = (state) => state.merge({ fetching: true })
const deleteUserBusinessAccountSuccess = (state, { payload: deletedBA }) => {
  const newResults = [...state.result.results].filter(
    (el) => el.id !== (deletedBA?.id || deletedBA)
  )
  return state.merge({
    fetching: false,
    result: {
      count: state.result?.length - 1,
      results: newResults
    }
  })
}

const businessAccountsFailure = (state) => state.merge({
  fetching: false,
  fetchingBaComment: false
})

const clearBaCommentsData = (state) => state.merge({
  baCommentData: null,
})

export const businessAccountsSetProp = (state, { key, value }) => {
  const obj = {}
  if (["filters", "visibleFilters", "visibleFiltersAdmin"]?.includes(key)) {
    if (key === "filters") obj.filtersLastUpd = new Date().getTime()
    obj[key] = { ...state?.[key], ...value }
  } else {
    obj[key] = value
  }
  return state.merge(obj)
}

export const clearBusinessAccountsFilters = (state) => {
  return state.merge({ filters: INITIAL_STATE.filters })
}

const getBusinessAccountsExportRequest = (state) => state.merge({ exportFetching: true })
const getBusinessAccountsExportSuccess = (state, { payload: exportResult }) =>
  state.merge({
    exportFetching: false,
    exportResult
  })
const getBusinessAccountsExportFailure = (state) => state.merge({ exportFetching: false })

const getAlertsChartRequest = (state) => state.merge({ chartLoading: true, chartData: {} })

const getAlertsChartSuccess = (state, { payload: data }) =>
  state.merge({ chartLoading: false, chartData: data })

const getAlertsChartFailure = (state) =>
  state.merge({
    chartLoading: false,
    chartData: {
      last_updated: null,
      chart: {
        labels: [],
        result: {}
      },
      total_value: null
    }
  })

const logout = (state) => {
  return state.merge({
    ...INITIAL_STATE,
    filters: state.filters,
    columnsAdmin: state.columnsAdmin,
    visibleFiltersAdmin: state.visibleFiltersAdmin
  })
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_BUSINESS_ACCOUNTS_FILTER_OPTIONS_REQUEST]: getBusinessAccountsFilterOptionsRequest,
  [Types.GET_BUSINESS_ACCOUNTS_FILTER_OPTIONS_SUCCESS]: getBusinessAccountsFilterOptionsSuccess,
  [Types.GET_BUSINESS_ACCOUNTS_FILTER_OPTIONS_FAILURE]: getBusinessAccountsFilterOptionsFailure,

  [Types.GET_ADMIN_BUSINESS_ACCOUNTS_REQUEST]: getAdminBusinessAccountsRequest,
  [Types.GET_ADMIN_BUSINESS_ACCOUNTS_SUCCESS]: getAdminBusinessAccountsSuccess,

  [Types.GET_BA_COMMENT_DATA_REQUEST]: getBaCommentDataRequest,
  [Types.GET_BA_COMMENT_DATA_SUCCESS]: getBaCommentDataSuccess,

  [Types.SAVE_BA_COMMENT_REQUEST]: saveBaCommentRequest,
  [Types.SAVE_BA_COMMENT_SUCCESS]: saveBaCommentSuccess,

  [Types.DELETE_BA_COMMENT_REQUEST]: deleteBaCommentRequest,
  [Types.DELETE_BA_COMMENT_SUCCESS]: deleteBaCommentSuccess,

  [Types.DELETE_BA_COMMENT_ATTACHMENT_REQUEST]: deleteBaCommentAttachmentRequest,
  [Types.DELETE_BA_COMMENT_ATTACHMENT_SUCCESS]: deleteBaCommentAttachmentSuccess,

  [Types.DELETE_USER_BUSINESS_ACCOUNT_REQUEST]: deleteUserBusinessAccountRequest,
  [Types.DELETE_USER_BUSINESS_ACCOUNT_SUCCESS]: deleteUserBusinessAccountSuccess,

  [Types.BUSINESS_ACCOUNTS_FAILURE]: businessAccountsFailure,

  [Types.CLEAR_BUSINESS_ACCOUNTS_FILTERS]: clearBusinessAccountsFilters,

  [Types.CLEAR_BA_COMMENTS_DATA]: clearBaCommentsData,

  [Types.BUSINESS_ACCOUNTS_SET_PROP]: businessAccountsSetProp,

  [Types.GET_BUSINESS_ACCOUNTS_EXPORT_REQUEST]: getBusinessAccountsExportRequest,
  [Types.GET_BUSINESS_ACCOUNTS_EXPORT_SUCCESS]: getBusinessAccountsExportSuccess,
  [Types.GET_BUSINESS_ACCOUNTS_EXPORT_FAILURE]: getBusinessAccountsExportFailure,

  [Types.GET_ALERTS_CHART_REQUEST]: getAlertsChartRequest,
  [Types.GET_ALERTS_CHART_SUCCESS]: getAlertsChartSuccess,
  [Types.GET_ALERTS_CHART_FAILURE]: getAlertsChartFailure,

  [Types.GET_STATISTICS_ADMIN_REQUEST]: getStatisticsAdminRequest,
  [Types.GET_STATISTICS_ADMIN_SUCCESS]: getStatisticsAdminSuccess,
  [Types.GET_STATISTICS_ADMIN_FAILURE]: getStatisticsAdminFailure,

  [Types.LOGOUT]: logout
})
